'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';

import ChevronIcon from '@/fo/icons/base/icons/chevron.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitCollapseBase } from '@/fo/ui/kit/collapse/base';

import { styles } from './UiKitSectionSeoText.styles';

const LINE_CLAMP = 5;

export interface UiKitSectionSeoTextProps {
  children: React.ReactNode;
  title?: React.ReactNode;
}

/**
 * Для отображаемого текста стоит ограничение на 5 строк, дальше сткрыто за «...»
 */
export function UiKitSectionSeoText({
  children,
  title = '',
  ...props
}: UiKitSectionSeoTextProps) {
  const [isCollapse, setIsCollapse] = useState(true);
  const [showCollapseButton, setShowCollapseButton] = useState(true);

  const t = useTranslations();

  const slots = styles();

  const onCheckLineClampActive = (active: boolean) => {
    setShowCollapseButton(active);
  };

  return (
    <div
      className={slots.base()}
      {...props}
    >
      {title && <div className={slots.title()}>{title}</div>}

      <div className={slots.content()}>
        <UiKitCollapseBase
          lineClamp={LINE_CLAMP}
          collapse={isCollapse}
          onCheckLineClampActive={onCheckLineClampActive}
        >
          <div>{children}</div>
        </UiKitCollapseBase>

        {showCollapseButton && (
          <UiKitButtonBase
            className={slots.collapseButton()}
            onClick={() => setIsCollapse((s) => !s)}
            color="tertiary"
          >
            {isCollapse ? t('more') : t('hide')}
            <ChevronIcon
              className={slots.arrow({
                className: isCollapse ? 'rotate-90' : '-rotate-90'
              })}
            />
          </UiKitButtonBase>
        )}
      </div>
    </div>
  );
}
